import React from "react";
import moment from "moment";
import "../Styles/_OrderSummary.css";

const OrderSummary = ({ currentLanguage, order }) => {
    if (!order) {
        return <div className="order-summary-container">No order information available</div>;
    }

    const {
        name,
        preorder,
        created_at,
        total_line_items_price_formatted,
        total_discounts,
        total_discounts_formatted,
        total_shipping_formatted,
        total_tax_formatted,
        total_refunded,
        total_refunded_formatted,
        currency,
        total_price_formatted
    } = order;

    const {
        ORDER_PAGE: {
            SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                ORDER_SUMMARY: { HEADING, ITEMS_SUBTOTAL_TITLE, DISCOUNT_TITLE, SHIPPING_TITLE, TAXES_TITLE, REFUND_TITLE, GRAND_TOTAL_TITLE }
            }
        },
        MISC: { PREORDER }
    } = currentLanguage;

    return (
        <div className="order-summary-container allow-focus" tabIndex="0">
            <h2 className="title">{HEADING}</h2>
            <div className="layout horizontal order-name">
                <div>{name}</div>
                <div className="layout horizontal order-tags">{preorder && <div className="tag">{PREORDER}</div>}</div>
            </div>

            <p className="order-date">{moment(created_at).format("LLL")}</p>
            <div className="summary-divider"></div>
            <div className="summary-line-container">
                <div className="summary-line-label">{ITEMS_SUBTOTAL_TITLE}:</div>
                <div className="summary-line-value">{total_line_items_price_formatted}</div>
            </div>
            {total_discounts > 0 && (
                <div className="summary-line-container">
                    <div className="summary-line-label">{DISCOUNT_TITLE}:</div>
                    <div className="summary-line-value">-{total_discounts_formatted}</div>
                </div>
            )}
            <div className="summary-line-container">
                <div className="summary-line-label">{SHIPPING_TITLE}:</div>
                <div className="summary-line-value">{total_shipping_formatted}</div>
            </div>
            <div className="summary-line-container">
                <div className="summary-line-label">{TAXES_TITLE}:</div>
                <div className="summary-line-value">{total_tax_formatted}</div>
            </div>
            {total_refunded > 0 && (
                <div className="summary-line-container">
                    <div className="summary-line-label">{REFUND_TITLE}:</div>
                    <div className="summary-line-value">-{total_refunded_formatted}</div>
                </div>
            )}
            <div className="summary-divider"></div>
            <div className="summary-line-container">
                <div className="summary-line-label total">{GRAND_TOTAL_TITLE}:</div>
                <div className="summary-line-value total">
                    <p className="total-price">{currency ? `${currency} ${total_price_formatted}` : total_price_formatted}</p>
                </div>
            </div>
        </div>
    );
};

export default OrderSummary;
